import { getCuratorImage } from '@vaultsfyi/common/utils'
import { RoundImage } from './roundImage'

interface CuratorImageProps {
  curator: string
  className?: string
}

export const CuratorImage = ({ curator, className }: CuratorImageProps) => {
  return (
    <RoundImage
      src={getCuratorImage(curator)}
      fallback={getCuratorImage('fallback')}
      alt={curator}
      className={className}
    />
  )
}
